import type { TaskEitherTs } from "@ps-bridge/interop";

export type SdeWorkbookClientError =
    | { readonly type: "NetworkError"; readonly message: string }
    | { readonly type: "BackendError"; readonly message: string; readonly status: number }
    | { readonly type: "ResponseDecodeError"; readonly message: string };

export const sdeWorkbookClientErrorMessage = (error: SdeWorkbookClientError): string => {
    if (error.type === "NetworkError") {
        return error.message;
    }
    if (error.type === "ResponseDecodeError") {
        return "The SDE workbook service returned an unreadable XLSX response.";
    }
    return error.message.trim() === "" ? `SDE workbook generation failed with HTTP ${error.status}.` : error.message;
};

export interface SdeWorkbookClient {
    readonly generateWorkbook: (file: File) => TaskEitherTs<SdeWorkbookClientError, Blob>;
}
